<template>
  <div class="flex flex-col h-screen w-full pt-16 overflow-y-auto">
    <div class="flex w-full h-full">
      <div class="flex flex-col w-7/12 pt-4 items-center px-4">
        <h1 class="font-black mb-2 text-xl text-teal-900">Sentence</h1>
        <!-- Begin senetence display part -->
          <div
            class="h-full flex flex-wrap justify-center items-center border-2 w-full mb-4 rounded border-teal-500 relative overflow-y-auto relative"
            @mouseup="getSelectionWithinInput">
            <div class="text-center text-base absolute p-10" v-if="currentSentence" v-html="currentSentence"></div>
            <div class="text-center text-base z-10 absolute p-10" v-if="currentSentenceLayer" v-html="currentSentenceLayer"></div>
          </div>
        
        <!-- End of senetence display part -->
        <!-- Navigation -->
        <div>
          <button class="button-direction" @click="previousSentence"><i class="fas fa-arrow-left text-xl text-teal-500"></i></button>
          <p class="font-bold bg-white p-2 inline" v-if="sentences">{{ currentIndex + 1 }} / {{ sentences.length }}</p>
          <button class="button-direction" @click="nextSentence"><i class="fas fa-arrow-right text-xl text-teal-500"></i></button>
        </div>
        <!-- End Navigation -->
      </div>
      <div class="flex w-5/12 flex-col px-8 pt-4 items-center h-full">
        <h1 class="font-black text-xl text-teal-900 mb-2">Sentence</h1>
        <thead class="w-full">
          <tr class="w-full flex">
            <!-- <th class="w-24 py-4 bg-teal-200 font-bold uppercase text-xs text-teal-700 border-b border-teal-300">Select</th> -->
            <th class="w-2/6 py-4 bg-teal-200 font-bold uppercase text-xs text-teal-700 border-b border-teal-300">Entity 1</th>
            <th class="w-2/6 py-4 bg-teal-200 font-bold uppercase text-xs text-teal-700 border-b border-teal-300">Relation</th>
            <th class="w-2/6 py-4 bg-teal-200 font-bold uppercase text-xs text-teal-700 border-b border-teal-300">Entity 2</th>
            <th class="w-24 py-4 bg-teal-200 font-bold uppercase text-xs text-teal-700 border-b border-teal-300">Delete</th>
          </tr>
        </thead>
        <div v-if="sentences">
          <tbody class="w-full overflow-y-auto border-b border-gray-300">
            <tr class="w-full flex hover:bg-gray-100 border-b border-grey-100" v-for="item in sentences[currentIndex].sets" 
              :key="item.id"
              @click="currentEditing = item.id"
              :class="{'bg-gray-200': item.id === currentEditing}" >
              <!-- SELECT -->
              <!-- <td class="w-16 py-2 px-2 border-r border-l border-gray-300">
                <radio :id="'radio' + item.id" :index="items.id" @activate-edit="currentEditing = $event"></radio>
              </td> -->
              <!-- ENTITY 1 -->
              <td class="w-2/6 py-2 px-2 border-r border-gray-300" :class="[currentEditing == item.id ? 'pointer-events-auto' : 'pointer-events-none']">
                <entity-relation 
                  :value="item.entity_1.word"
                  :type="'entity_1'"
                  :startEditingWord="startEditingWord"
                  :finishEditingWord="finishEditingWord"></entity-relation>
              </td>
              <!-- Relation -->
              <td class="w-2/6 py-2 px-2 border-r border-gray-300" :class="[currentEditing == item.id ? 'pointer-events-auto' : 'pointer-events-none']">
                <entity-relation 
                  :value="item.relation.word"
                  :type="'relation'"
                  :startEditingWord="startEditingWord"
                  :finishEditingWord="finishEditingWord"></entity-relation>
              </td>
              <!-- Entity 2 -->
              <td class="w-2/6 py-2 px-2 border-r border-gray-300" :class="[currentEditing == item.id ? 'pointer-events-auto' : 'pointer-events-none']">
                <entity-relation 
                  :value="item.entity_2.word"
                  :type="'entity_2'"
                  :startEditingWord="startEditingWord"
                  :finishEditingWord="finishEditingWord"></entity-relation>
              </td>
              <!-- Delete -->
              <td class="w-16 py-2 px-2 border-r border-gray-300" :class="[currentEditing == item.id ? 'pointer-events-auto' : 'pointer-events-none']">
                <button @click="deleteWord(item.id)" class="border m-1 border-white flex-shrink-0 w-5 h-5 rounded-full bg-red-500 focus:outline-none hover:bg-red-700 flex items-center justify-center">
                  <i class="fas fa-minus text-sm text-white"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </div>

        <button  
          class="button-plusmin mt-4 text-teal-200 w-full py-1 bg-teal-700 focus:outline-none flex items-center justify-center rounded"
          v-if="sentences"
          @click="addWord">
          <i class="fas fa-plus text-xl"></i>
        </button>
      </div>
    </div>
    <div class="flex m-3 items-center justify-center">
      <button @click="showOrHide" class="button-action w-32 h-10 rounded mx-4 bg-teal-700 text-teal-200" :disabled="editingGlobal">
        See Previous List</button>
      <button @click="getSentences" class="button-action w-24 h-10 rounded mx-4 bg-teal-700 text-teal-200" :disabled="editingGlobal">
        Display</button>
      <button @click="saveResultAction" class="button-action w-24 h-10 rounded mx-4 bg-teal-700 text-teal-200" :disabled="!editingGlobal">
        Save</button>
    </div>
    <previous-list :show="showPreviousList" :goBack="showOrHide"></previous-list>
  </div>
</template>

<script>
import axios from 'axios';
import { ToggleButton } from 'vue-js-toggle-button';
import _ from 'lodash';

import REPreviousList from '@/components/REPreviousList';
import { relationExtractionData } from '@/data';
import Radio from '@/components/Radio';
import EntityRelation from '@/components/EntityRelation';
import { makeid, colorizer, getWordsIndexCoordinate, joinArrayRange } from '@/helpers';

export default {
  data() {
    return {
      currentIndex: 0,
      currentSentence: '',
      currentSentenceLayer: '',
      editingGlobal: false,
      sentences: '',
      currentEditing: null,
      pollInEdit: null,
      showPreviousList: false
    }
  },
  components: {
    Radio,
    EntityRelation,
    PreviousList: REPreviousList
  },
  methods: {
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    },
    hightlightIt(text) {
      if(!text)
        return 'No Text';

      let str = text
      const words = this.sentences[this.currentIndex].sets.filter(item => item.id === this.currentEditing);
   
      if (words[0].entity_1.word) {
        str = str.replace(new RegExp(this.escapeRegExp(words[0].entity_1.word) + "(?![^<]*</span>)"), match => {
          return `<span style="background: #F6AD55">${match}</span>`;
        });
      }
      if (words[0].relation.word) {
        str = str.replace(new RegExp(this.escapeRegExp(words[0].relation.word) + "(?![^<]*</span>)"), match => {
          return `<span style="background: #68D391">${match}</span>`;
        });
      }
      if (words[0].entity_2.word) {
        str = str.replace(new RegExp(this.escapeRegExp(words[0].entity_2.word) + "(?![^<]*</span>)"), match => {
          return `<span style="background: #F687B3">${match}</span>`;
        });
      }

      this.currentSentence = str;
    },
    getSelectionWithinInput() {
      let selection = '';
      let position = '';
      if (window.getSelection().toString()) {
        const start = window.getSelection().getRangeAt(0).startOffset;
        const end = window.getSelection().getRangeAt(0).endOffset;
        
        selection = window.getSelection().toString();
        position = [start, end];

        console.log(selection + ' ' + position + ' start:' + start + ' end:' + end);
      };

      if (this.pollInEdit === 'entity_1') {
        this.changer('entity_1', selection, position);
      } else if (this.pollInEdit === 'relation') {
        this.changer('relation', selection, position);
      } else if (this.pollInEdit === 'entity_2') {
        this.changer('entity_2', selection, position);
      }
    },
    changer(thing, selection, position) {
      for (let item of this.sentences[this.currentIndex].sets) {
        if (item.id === this.currentEditing) {
          item[thing].word = selection;
          item[thing].position = position;
          break;
        }
      }
    },
    pageChanges() {
      this.currentSentence = this.sentences[this.currentIndex].sentence;
      this.currentSentenceLayer = this.sentences[this.currentIndex].sentence;
      this.currentEditing = null;
      this.pollInEdit = null;
    },
    nextSentence() {
      if (this.currentIndex < this.sentences.length - 1) {
        this.currentIndex += 1;
        this.pageChanges();
      }
    },
    previousSentence() {
      if (this.currentIndex > 0) {
        this.currentIndex -= 1;
        this.pageChanges();
      }
    },
    getSentences() {
      // USE THIS CODE PART FOR REAL DATA
      // axios.get(baseUrl + 'CHANGE FOR LOCAL ENDPOINT')
      //   .then(response => {
      //     this.sentences = response.data;
      //     this.currentSentence = this.sentences[0].complete_sentence;
      //     this.currentSentenceLayer = this.sentences[0].complete_sentence;
      //     this.editingGlobal = true;
      //   })
      //   .catch(error => {
      //     this.$swal({
      //       type: 'error',
      //       title: 'Oops',
      //       text: 'Your request is failed'
      //     });
      //   });

      // USE THIS CODE PART FOR WORKING WITH DUMMY DATA
      // NOTE, ACTUAL DATA PROVIDED BY KETAN DOESNT HAVE AN ID
      this.sentences = relationExtractionData;
      this.currentSentence = relationExtractionData[0].sentence;
      this.currentSentenceLayer = relationExtractionData[0].sentence;
      this.editingGlobal = true;
    },
    startEditingWord(poll) {
      this.pollInEdit = poll;
    },
    finishEditingWord() {
      this.pollInEdit = null;
      this.hightlightIt(this.sentences[this.currentIndex].sentence);
    },
    deleteWord(id) {
      this.$swal({
        title: 'Are you sure?', text: 'You can\'t revert your action', type: 'warning',
        showCancelButton: true, confirmButtonText: 'Yes Delete it!', cancelButtonText: 'No, Keep it!',
        showCloseButton: true, showLoaderOnConfirm: true
      }).then((result) => {
        if(result.value) {
          this.sentences[this.currentIndex].sets = this.sentences[this.currentIndex].sets.filter(item => item.id !== id);
          this.currentEditing = null;
          this.$swal('Deleted', 'You successfully deleted the record', 'success')
        } else {
          this.$swal('Cancelled', 'Your record is still intact', 'info')
        }
      })
    },
    addWord() {
      const id = makeid(8);
      this.sentences[this.currentIndex].sets.unshift({ 
        id, 
        entity_1: { word: '', position: [null, null] },
        entity_2: { word: '', position: [null, null] },
        relation: { word: '', position: [null, null] }
      });
      this.currentEditing = id;
    },
    showOrHide() {
      this.showPreviousList = !this.showPreviousList;
    },
    saveResultAction() {
      // USE THIS CODE PART FOR REAL DATA
      // axios.post(baseUrl + 'CHANGE FOR LOCAL ENDPOINT', this.sentences)
      //   .then(resp => {
      //     this.savedResult = resp.data.score;
      //     this.editingGlobal = false;
      //     this.currentSentenceLayer = '';
      //     this.sentences = '',
      //     this.currentSentence = '';
      //     this.currentIndex = 0;
      //     this.currentEditing = null;
      //     this.$swal({
      //         type: 'success',
      //         title: 'Save Result',
      //         text: 'The train result is' + this.savedResult
      //     });
      //   })
      //   .catch(err => {
      //     this.$swal({
      //       type: 'error',
      //       title: 'Oops',
      //       text: 'Your request is failed'
      //     });
      //   });

      // USE THIS CODE PART FOR WORKING WITH DUMMY DATA
      this.editingGlobal = false;
      this.currentSentenceLayer = '';
      this.sentences = '',
      this.currentSentence = '';
      this.currentIndex = 0;
      this.currentEditing = null;
    },
  },
  watch: {
    currentEditing: function() {
      if (this.currentSentence) {
        if (this.currentEditing) {
          this.hightlightIt(this.sentences[this.currentIndex].sentence);
        } else {
          this.currentSentence = this.sentences[this.currentIndex].sentence;
        }
      }
    }
  }
}
</script>

<style></style>
